import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';
import getLogger from '../../../utils/logger';

const getCartItemsCount = async () => {
  const logger = getLogger();
  // Get auth header config
  const config = await getConfig();
  const requestUrl = `api/rcore/shoppingCart/getCartItems`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data.totalItems;
    })
    .catch((err) => {
      logger.error(err.response);
      return null;
    });
};

export default getCartItemsCount;
